import { createApp, reactive } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from "element-plus";
import "animate.css"
import "element-plus/dist/index.css";
import "./components/css/common.css";
import "./components/css/common.scss";
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import "@/svgIcon/index";
import svgIcon from "@/svgIcon/index.vue";
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import print from 'vue3-print-nb';
import VueI18n from './components/js/language';

const app = createApp(App)

//全局引入icon图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}
//注册全局变量
let globalVars = reactive({
    innerHeight: 937,
})
app.provide('globalVars', globalVars)

//自定义指令（节流-防止重复点击）
app.directive('preventReClick', {
    mounted: function (el, binding, vNode, oldVnode) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                /* el.style.cursor='not-allowed' */
                el.style.cursor='wait'
                setTimeout(() => {
                    el.disabled = false
                    el.style.cursor='pointer'
                }, 2000)
            }
        },
        )
    }
})


app.use(store).use(router).use(print).use(VueI18n).use(ElementPlus, { locale: zhCn }).component('svg-icon', svgIcon).mount('#app')

/* 阻止table渲染报错 */
const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
    }
}